// 新手引导关卡数据
import request from '@/utils/request';
export function onlineDataac(data) {
  return request({
    url: '/data/account_online_data',
    method: 'get',
    params: data
  });
}